import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-wireless-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./wireless-create.component.scss']
})
export class WirelessCreateComponent extends UserCreateComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'wireless';
  }

  getMeta(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const meta = await super.getMeta();
      if (!this.isEdit) {
        const next = await this.service.apiCall('api/user/getNextUsername', { service_type: this.subentityName }).toPromise();
        meta.fields.find(f => f.name === 'username').value = next.name;
        meta.fields.splice(meta.fields.findIndex(c => c.name === 'tags'), 0, {
          name: 'password',
          caption: this.translator.instant('PASSWORD'),
          value: UUID.UUID().substr(0, 8),
          type: {
            name: 'text',
            readOnly: true
          }
        });
        resolve(meta);
      } else {
        resolve(meta);
      }
    });
  }
}
